import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import queryString from 'query-string'
import { Loading } from './Loading'
import Auth from '../../Auth'
import Source from '../../Source'
import { setGrayBody } from './BodyBg'
const auth = new Auth();
const source = new Source();

export class Order extends Component {
    constructor(props) {
        super(props);

        this.state = {
            templateId: '',
            templateTitle: '',
            templatePrice: 0,
            payMethod: "1",
            isDialogOpen: false,
            message: "",
            isLoading: true,
            needBack: false
        }
        console.log(this.state)
    }

    componentDidMount() {
        setGrayBody();
        const parsed = queryString.parse(window.location.search);
        console.log(parsed)
        var url = '/api/template/FindTemplate?id=' + parsed.templateId;

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(
            Response => {
                this.setState({ isLoading: false });
                console.log(Response.status)

                if (Response.ok) {
                    return Response.json();
                }

                if (Response.status === 404) {
                    this.setState({ isDialogOpen: true, needBack: true, message: '模板不存在或已下架' });
                    return '';
                }

                throw new Error('服务器错误');
            }
        ).then(
            json => {
                if (json) {
                    this.setState({ templateId: json.Id, templateTitle: json.Title, templatePrice: json.Price, showLoading: false });
                }
            }
        )
    }

    handleDialogOk = () => {
        if (this.state.needBack) {
            this.setState({ isDialogOpen: false, message: '' })
            this.props.history.goBack();
        } else {
            this.setState({ isDialogOpen: false, message: '' })
        }
    }

    handleRadioClick = (e) => {
        this.setState({ payMethod: e.target.value })
        console.log(this.state);
    }

    handleSubmitOrder = () => {
        const options = {
            'headers': {
                ...auth.options(),
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }

        let code = source.getSource() === undefined ? "" : source.getSource().code;
        let data = { templateId: this.state.templateId, payMethod: this.state.payMethod, source: code };
        this.setState({ isLoading: true });

        fetch('/api/Order/CreateOrder', {
            ...options,
            method: 'POST',
            body: JSON.stringify(data)
        }).then(
            Response => {
                this.setState({ isLoading: false });
                console.log(Response.status)

                if (Response.ok) {
                    return Response.json();
                }

                if (Response.status === 401) {
                    auth.signOut();
                    this.props.history.push("/Login")
                }

                throw new Error('服务器错误');
            }

        ).then(
            (json) => {
                if (json.Success) {
                    console.log(json);
                    var url = "/";
                    if (this.state.payMethod === "1") {
                        url = "/AliPay?orderId=" + json.OrderId;
                    } else if (this.state.payMethod === "2") {
                        url = "/WechatPay?orderId=" + json.OrderId;
                    }
                    console.log(url);
                    this.props.history.push(url);
                } else {
                    this.setState({ isDialogOpen: true, message: json.Message });
                }
            }
        ).catch(error => {
            this.setState({ isLoading: false });
            console.error(error);
        })
    }

    render() {
        const { templateId, templateTitle, templatePrice } = this.state

        return (
            <div className="top pt-4">
                <div className="w-box p-5">
                    <div className="mb-4">
                        <div className="w-box-title">订单提交</div>
                    </div>

                    <div className="w-box-content mb-4">
                        <div className="point">
                            <div></div>
                        </div>
                        <div className="font-yellow font-l">提示：</div>
                        <div className="pt-1 font-gray">
                            1、注意，由于文档商品的特殊性，购买后不支持退货或换货！<br />

                            2、购买后您可以查看该文档全文，并可以下载与自行使用。<br />

                            3、购买后您可以使用，但原文档的知识产权仍为原作者所保留，请勿向公开渠道传播。
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-box-title">模板名称</div>
                        <div className="pt-4 w-box-content no-border">
                            <div>{templateTitle}</div>
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="w-box-title">支付方式</div>
                        <div className="w-box-content no-border pt-4">

                            <input className="d-none" type="radio" value="1" name="method" id="alipay" checked={this.state.payMethod === "1"} onChange={this.handleRadioClick.bind(this)} />
                            <label className="get-order-label" htmlFor="alipay"><span className="alipay"> 支付宝</span></label>

                            <input className="d-none" type="radio" value="2" name="method" id="weixinzhifu" checked={this.state.payMethod === "2"} onChange={this.handleRadioClick.bind(this)} />
                            <label className="get-order-label" htmlFor="weixinzhifu"><span className="weixinzhifu"> 微信支付</span></label>
                        </div>
                    </div>
                    <div className="mb-4">
                        <div className="w-box-title">订单金额</div>

                        <div className="pt-4 w-box-content no-border">
                            总额：{Number(templatePrice).toFixed(2)}元
                    </div>
                    </div>

                    <div className="w-box-content no-border">
                        <div className="bor-top pt-4">
                            <button type="button" className="btn fts-btn fts-btn-warning" onClick={this.handleSubmitOrder.bind(this)}>提交订单</button>
                        </div>
                    </div>

                </div>

                {this.state.isDialogOpen && <Dialog title="提示" style={{ width: "300px;" }} closeIcon={false}>
                    <p style={{ margin: "10px", width: "200px" }}>{this.state.message}</p>
                    <DialogActionsBar>
                        <button className="k-button" onClick={this.handleDialogOk.bind(this)}>确定</button>
                    </DialogActionsBar>
                </Dialog>}

                <Loading isLoading={this.state.isLoading} />
            </div>

        )
    }
}

export default Order